"use client";

import * as brands from "@assets/image/brands";
import Image from "next/image";
import Link from "next/link";
import Marquee from "react-fast-marquee";

const toSlug = (key: string) => key.toLowerCase().replace(/_/g, "-");

const images = Object.entries(brands).map(([key, img]) => ({
  src: (img as { src: string }).src,
  alt: key.replace(/_/g, " "),
  slug: toSlug(key),
}));

function Brands() {
  return (
    <Marquee speed={40} gradient={false} pauseOnHover={true} className="bg-white lg:py-2">
      {images.map((logo, index) => (
        <Link href={`/product-search?q=${logo.slug}`} key={index} className="mx-8">
          <Image
            src={logo.src}
            alt={logo.alt}
            width={180}
            height={80}
            loading="lazy"
            className="object-contain hover:scale-125 transition-all lg:w-[180px] lg:h-[80px] w-[120px]"
          />
        </Link>
      ))}
    </Marquee>
  );
}

export default Brands;
